export type PlannerRegion = "my" | "sg" | "dev";

export interface RegionalDestination {
  readonly region: PlannerRegion;
  readonly plannerOrigin: string;
  readonly dashboardUrl: string;
  readonly bulkPickBaseUrl: string;
}

const REGIONAL_DESTINATIONS: Readonly<Record<PlannerRegion, RegionalDestination>> = {
  my: {
    region: "my",
    plannerOrigin: "https://pick-planner.boostware.my",
    dashboardUrl: "https://dashboard.boostware.my/",
    bulkPickBaseUrl: "https://dashboard.boostware.my/warehouse/outbound/bulk-pick/new",
  },
  sg: {
    region: "sg",
    plannerOrigin: "https://pick-planner.boostware.sg",
    dashboardUrl: "https://dashboard.boostware.sg/",
    bulkPickBaseUrl: "https://dashboard.boostware.sg/warehouse/outbound/bulk-pick/new",
  },
  dev: {
    region: "dev",
    plannerOrigin: "https://pick-planner.sellnship.io",
    dashboardUrl: "https://dev-dashboard.sellnship.io/",
    bulkPickBaseUrl: "https://dev-dashboard.sellnship.io/warehouse/outbound/bulk-pick/new",
  },
};

const LOCAL_DEVELOPMENT_ORIGINS = new Set(["http://127.0.0.1:5173", "http://localhost:5173"]);

export function resolveRegionalDestination(
  plannerOrigin: string,
  localDevelopmentRegion?: PlannerRegion,
): RegionalDestination | null {
  const exactOrigin = parseExactOrigin(plannerOrigin);
  if (exactOrigin === null) return null;

  for (const destination of Object.values(REGIONAL_DESTINATIONS)) {
    if (destination.plannerOrigin === exactOrigin) return destination;
  }

  if (localDevelopmentRegion !== undefined && LOCAL_DEVELOPMENT_ORIGINS.has(exactOrigin)) {
    return REGIONAL_DESTINATIONS[localDevelopmentRegion];
  }
  return null;
}

function parseExactOrigin(value: string): string | null {
  try {
    const url = new URL(value);
    if (
      url.origin !== value ||
      url.username !== "" ||
      url.password !== "" ||
      url.pathname !== "/" ||
      url.search !== "" ||
      url.hash !== ""
    ) {
      return null;
    }
    return url.origin;
  } catch {
    return null;
  }
}
